import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { Search as SearchIcon } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import ClearableTextField from 'app/components/shared/ClearableTextField';

import './SearchBar.scss';

class SearchBar extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.state = { query: this.props.query };
  }

  componentDidUpdate(prevState) {
    if (prevState.query !== this.props.query) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ query: this.props.query });
    }
  }

  handleQueryCleared() {
    this.handleQueryChange('');
    if (this.props.handleClear) {
      this.props.handleClear();
    }
  }

  handleQueryChange(value) {
    this.updateQuery(value);

    if (this.props.handleChange) {
      this.props.handleChange(value);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.handleSearch(this.state.query);
  }

  updateQuery(query) {
    if (this.state.query !== query) {
      this.setState({ query });
    }
  }

  renderLabelText() {
    if (this.props.label) {
      return this.props.label;
    }

    return <FormattedMessage id="ada_label_search_box" />;
  }

  renderLabel() {
    const label = (
      <label id="search-bar-label" className="search-bar-label" htmlFor="search-bar-query">
        {this.renderLabelText()}
      </label>
    );

    if (!this.props.label) {
      return <ScreenReaderMessage>{label}</ScreenReaderMessage>;
    }

    return label;
  }

  renderFormWrapper() {
    // A non-empty form action is required for having a search button appear on iOS 8+
    // See http://stackoverflow.com/questions/4864167/show-search-button-in-iphone-ipad-safari-keyboard
    return (
      <form className="search-bar-form" action=".">
        {this.renderContent()}
      </form>
    );
  }

  renderContent() {
    const { placeholder, focus } = this.props;
    return (
      <div>
        {this.renderLabel()}
        <div className="search-bar-holder">
          <ClearableTextField
            id="search-bar-query"
            value={this.state.query}
            labelledById="search-bar-label"
            describedById="search-bar-input"
            handleChange={this.handleQueryChange}
            handleClear={this.handleQueryCleared}
            hideClearButton={!this.state.query}
            placeholder={placeholder}
            focus={focus}
            type="search"
            className="search-box"
            clearButtonSrText={<FormattedMessage id="ada_label_clear_search_text" />}
            inputTestId="search-bar-query"
          />
          <PrimaryButton className="search-btn" handleClick={this.handleSubmit} flat data-test-id="search-button">
            <ScreenReaderMessage>
              <FormattedMessage id="button_search" />
            </ScreenReaderMessage>
            <SearchIcon color="" />
          </PrimaryButton>
        </div>
      </div>
    );
  }

  render() {
    const { isWrappedInForm } = this.props;

    return <div className="cp-search-bar">{isWrappedInForm ? this.renderFormWrapper() : this.renderContent()}</div>;
  }
}

SearchBar.propTypes = {
  focus: PropTypes.bool,
  placeholder: PropTypes.string,
  query: PropTypes.string,
  handleChange: PropTypes.func,
  handleSearch: PropTypes.func.isRequired,
  handleClear: PropTypes.func,
  isWrappedInForm: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

SearchBar.defaultProps = {
  query: '',
  isWrappedInForm: true
};

export default SearchBar;
